import { IPaymentMethod, IShippingMethod } from '@checkout/state';
import * as cx from 'classnames';
import { Field } from 'formik';
import * as React from 'react';
import { ChangeEvent, Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { InputBoxField, MessageBox } from '..';
import { klarnaPaymentsUriValues } from '../../../utils/paymentMethods';
import { checkIfArrayOfStringsContainsElement } from '../../../utils/utils';
import messages from './../../../i18n/base-en';
import * as Styles from './RadioGroup.scss';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'radiobox': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
      'radiogroup': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

interface IOwnProps {
  readOnly?: boolean;
  displayDirection?: 'row' | 'column';
  groupName: 'paymentMethod' | 'shippingMethod';
  selectedOption: string;
  options: Option[];
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  blockFor?: string;
}

type Props = IOwnProps & InjectedIntlProps;

type Option = IShippingMethod | IPaymentMethod;

class RadioGroup extends React.Component<Props, {}> {

  /* componentDidMount() {
    const { groupName, options, displayDirection, selectedOption } = this.props;

    if (isSmallDevice() &&
      options.length > 2 &&
      groupName === 'paymentMethod' &&
      displayDirection &&
      displayDirection === 'column') {
      setTimeout(function() {
        // @ts-ignore
        document.querySelectorAll(`input[value=${selectedOption}]`)[0].focus();
      }, 10);
    }
  } */

  render() {
    const { options, selectedOption, groupName, intl, onChange, displayDirection = 'row', blockFor, ...restProps } = this.props;
    const { formatMessage } = intl;

    if (!options || options.length === 0) { return null; }

    const containerClassNames = cx({
      [Styles.container]: true,
      [Styles.column]: displayDirection && displayDirection === 'column',
    });

    return (
      <Fragment>
        <div className={containerClassNames} data-block-for={blockFor}>
          {options.map((option: Option) => {
            let handlingCostText = undefined;
            const { name } = option;
            const shippingMethod = 'shippingMethod' in option ? option.shippingMethod : '';
            const paymentMethod = 'paymentMethod' in option ? option.paymentMethod : '';
            // const handlingCost = 'handlingCost' in option ? option.handlingCost : '';
            const value = shippingMethod || paymentMethod;
            const klarnaTermsElementId = 'clientSide' in option &&
              checkIfArrayOfStringsContainsElement(klarnaPaymentsUriValues, paymentMethod) ? paymentMethod : '';

            /* if ('paymentMethod' in option && option.handlingCostAsNumber !== 0) {
              handlingCostText = formatMessage(messages.payment_handling_cost_label, { handlingCost });
            } */

            if ('shippingMethod' in option) {
              handlingCostText = option.price;
            }

            return (
              <Field
                key={value}
                component={InputBoxField}
                displayRadioDirection={displayDirection}
                semanticType="radio"
                id={name}
                name={groupName}
                note={handlingCostText}
                label={name}
                value={value}
                onChange={onChange}
                checked={value === selectedOption}
                klarnaTermsElementId={klarnaTermsElementId}
                {...restProps}
              />
            );
          })}
        </div>
        {/* Show handling cost of payment method on the bottom of the payment radio group */}
        {options.map((option: Option) => {
          let handlingCostText = undefined;
          const handlingCost = 'handlingCost' in option ? option.handlingCost : '';
          if ('paymentMethod' in option && option.handlingCostAsNumber !== 0 && option.paymentMethod === selectedOption) {
            handlingCostText = formatMessage(messages.payment_handling_cost_label, { handlingCost });
          }
          return handlingCostText && <MessageBox type="info" spacingTop={true} message={handlingCostText} />;
        })}
      </Fragment>
    );
  }
}

export default injectIntl<IOwnProps>(RadioGroup);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/RadioGroup/RadioGroup.tsx